<!--
frontend-author:bhavya,
backend-author: ,
page-name :Sales by Customer.vue,
page-description :Sales by Customer for invoice,
started at : 15-Apr-2019,
edited at :16-Apr-2019.
-->
<!-- Html code for Sales by Customer-->
<template>
  <div>
    <b-row class="reports-header px-pad border-bottom" style="height:42px">
      <b-col xl="10" lg="10" md="10" sm="10" class="px-0">
        <GlobalDateRangePicker
          class="pr-3"
          ref="daterangeupdate"
          :singleDatePicker="false"
          v-on:setDateRange="getDateRange($event,datePickerReport)"
          :fromDate="from_date"
          :toDate="to_date"
        />
        <b-dropdown dropdown variant="light" size="sm" class="no-caret-dropdown mb-xs">
          <template slot="button-content">
            <span v-if="selectedfilter.filter_name">
              <i class="fa fa-filter la-lg mr-1"></i>
              {{selectedfilter.filter_name}}
            </span>
            <span v-else>
              <i class="la la-cog la-lg mr-1"></i>Customize Report
            </span>
          </template>
          <!-- For filter -->
          <b-dropdown-item v-b-modal.salescustomer>General</b-dropdown-item>
          <!-- To add columns -->
          <b-dropdown-item v-b-modal.custom_index>Show/hide columns</b-dropdown-item>

          <template v-if="reportsfilter.length>0">
            <b-dropdown-divider />
            <div class="mb-2">
              <span class="pl-4 text-link fw-semi-bold">Your Custom Filters</span>
            </div>
          </template>
          <b-dropdown-item v-for="item in reportsfilter" :key="item.id">
            <div class="d-flex">
              <a
                class="report_button mb-0 w-75 text-truncate"
                @click="runcustomreport(item)"
              >{{ item.filter_name }}</a>
              <i
                class="la la-edit la-lg text-right ml-2 mr-3 ml-auto"
                @click="filterpage = 'update',filteritems=item"
                v-b-modal.savefilterform
              ></i>
              <i
                class="glyphicon glyphicon-trash text-right"
                @click="handlingapprovingmodal({
                  content : 'Are you sure you want to delete this customize filter ?',
                  title : 'Delete customize filter - '+item.filter_name,
                  module:'general/deletecustomfilter',
                  data:JSON.stringify({
                    id : item.filter_id,
                    report_type: $route.meta.title
                  }),
                  RoutePlace:'',
                  isRoute:'false',
                  type: 'delete'
                })"
              ></i>
            </div>
          </b-dropdown-item>
        </b-dropdown>

        <span
          class="btn-link cursor_pointer ml-2 fw-semi-bold"
          v-if="!selectedfilter.filter_id"
          @click="filterpage = 'create',savefilterform()"
        >Save filter</span>
      </b-col>

      <b-col xl="2" lg="2" md="2" sm="2" class="px-0">
        <router-link class="event-link float-right mt-2" :to="{ name : 'Reports'}">
          <i class="la la-remove la-lg text-decoration-none text-dark"></i>
        </router-link>
        <b-dropdown dropdown variant="light" size="sm" class="no-caret-dropdown float-right mr-2">
          <template slot="button-content">
            <i class="la la-navicon la-lg"></i>
          </template>
          <b-dropdown-item class="dropdown-no-btn">
            <b-dropdown-item class="dropdown-no-btn" @click="exportModal()">
              <span class="la la-download mx-2"></span>Export Sales by Customer
            </b-dropdown-item>
            <!-- Download excel -->
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>
    <div>
      <b-row class="pt-2">
        <b-col lg="12" xl="12" md="12" sm="12" class="px-0">
          <div class="text-center text-normal">
            <p class="mb-1">{{ org_name }}</p>
            <h4 class="fw-semi-bold">Sales by Customer</h4>
            <p
              class="text-sm text-muted mb-2"
            >{{ 'From ' + getDateFormat(from_date) +' To '+ getDateFormat(to_date) }}</p>
          </div>

          <div class="table-responsive" id="reportScrollCol">
            <!--  sales by customer Table-->
            <table class="table table-bordered reports-table-border table-no-bordered">
              <!--  sales by customer Table head-->
              <thead class="tbl-col">
                <tr>
                  <th style="width:180px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'SalesCustomer',query: {sort:sort == 'asc' ? 'desc' : 'asc' ,label:'cus_name',from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,select_columns:$route.query.select_columns,custom:$route.query.custom,sales_tags:$route.query.sales_tags} }"
                    >
                      CUSTOMER
                      <small class="text-muted" v-if="label == 'cus_name'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>

                  <th style="width:140px !important" class="text-right">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'SalesCustomer',query: {sort:sort == 'asc' ? 'desc' : 'asc' ,label:'inv_count_id',from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,select_columns:$route.query.select_columns,custom:$route.query.custom,sales_tags:$route.query.sales_tags} }"
                    >
                      COUNT
                      <small class="text-muted" v-if="label == 'inv_count_id'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:140px !important" class="text-right">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'SalesCustomer',query: {sort:sort == 'asc' ? 'desc' : 'asc' ,label:'amt_without_tax',from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,select_columns:$route.query.select_columns,custom:$route.query.custom,sales_tags:$route.query.sales_tags} }"
                    >
                      SALES(BCY)
                      <small class="text-muted" v-if="label == 'amt_without_tax'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:140px !important" class="text-right">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'SalesCustomer',query: {sort:sort == 'asc' ? 'desc' : 'asc' ,label:'amt_with_tax',from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,select_columns:$route.query.select_columns,custom:$route.query.custom,sales_tags:$route.query.sales_tags} }"
                    >
                      WITH TAX(BCY)
                      <small class="text-muted" v-if="label == 'amt_with_tax'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:140px !important" class="text-right">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'SalesCustomer',query: {sort:sort == 'asc' ? 'desc' : 'asc' ,label:'cus_bal_amt',from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,select_columns:$route.query.select_columns,custom:$route.query.custom,sales_tags:$route.query.sales_tags} }"
                    >
                      BALANCE(BCY)
                      <small class="text-muted" v-if="label == 'cus_bal_amt'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <!-- Customize column -->
                  <th
                    v-for="(column) in reported_columns"
                    v-if="column.checked == true"
                    :key="column.id"
                    :style="{'width':column.colWidth+'px !important'}"
                    :class="{'text-right':column.align=='right'}"
                  >
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'SalesCustomer',query: {sort:sort == 'asc' ? 'desc' : 'asc' ,label:column.field,from_date:$route.query.from_date,
                      select_columns:$route.query.select_columns,to_date:$route.query.to_date,page: page,show: show,custom:$route.query.custom,sales_tags:$route.query.sales_tags} }"
                    >
                      {{ column.title }}
                      <small class="text-muted" v-if="label == column.field">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <!-- End of customize column header -->
                </tr>
              </thead>

              <!--  Sales by Customer Table body and data -->
              <tbody>
                <template v-if="lists.length == 0">
                  <tr>
                    <td colspan="6" class="text-center">No data to display</td>
                    <td
                      v-if="reported_columns.length > 0 && show_columns_length > 0"
                      :colspan="parseInt(reported_columns.length) - 0"
                    ></td>
                  </tr>
                </template>
                <template v-else>
                  <tr v-for="item in lists" :key="item.id" @click="oldRoute = $route.query">
                    <td style="width:180px !important">
                      <router-link
                        v-if="RoutePermission(false,'','invoice','customer','index')"
                        class="event-link theme-text-color"
                        :to="{ name : 'CustomerView',params:{id:item.cus_id}}"
                      >
                        <span class="text">{{ item.cus_name }}</span>
                      </router-link>
                      <template v-else>
                        <span class="text">{{ item.cus_name }}</span>
                      </template>
                    </td>

                    <td class="text-right">{{ item.inv_count_id }}</td>
                    <td class="text-right">
                      <router-link
                        class="text-decoration-none"
                        :to="{ name : 'SalesCustomerFilter',params:{id: item.cus_id},query: {name:item.cus_name,id: item.cus_id,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,select_columns:$route.query.select_columns,} }"
                      >{{ orgCurrencySymbol+" "+Number(item.amt_without_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                    </td>
                    <td class="text-right">
                      <router-link
                        class="text-decoration-none"
                        :to="{ name : 'SalesCustomerFilter',params:{id: item.cus_id},query: {name:item.cus_name,id: item.cus_id,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,select_columns:$route.query.select_columns,} }"
                      >{{ orgCurrencySymbol+" "+Number(item.amt_with_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                    </td>
                    <td class="text-right">
                      <router-link
                        class="text-decoration-none"
                        :to="{ name : 'SalesCustomerFilter',params:{id: item.cus_id},query: {name:item.cus_name,id: item.cus_id,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,select_columns:$route.query.select_columns,} }"
                      >{{ orgCurrencySymbol+" "+Number(item.cus_bal_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                    </td>
                    <!-- Customize column -->
                    <td
                      :style="{'width':column.colWidth+'px !important'}"
                      v-for="(column) in reported_columns"
                      v-if="column.checked == true"
                      :key="column.id"
                      :class="{'text-right':column.align=='right'}"
                    >
                      <span v-if="column.field=='place_of_supply'">
                        {{ getDetails(
                        $AppDetails.state_details,
                        item.place_of_supply,
                        "state_name")}}
                      </span>
                      <span
                        v-else-if="column.field=='cus_currency'"
                      >{{getDetails($AppDetails.currency_details,item.cus_currency,'currency_name')}}</span>

                      <span
                        v-else-if="column.field=='credit_limit'||column.field=='export_cus_bal_amt'||column.field=='export_amt_without_tax'||column.field=='export_amt_with_tax'"
                      >
                        {{ getDetails(
                        $AppDetails.currency_details,
                        item.customer_currency,
                        "currency_symbol"
                        )+ " "+Number(item[column.field]).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                      </span>

                      <span
                        :class="{'text':column.align=='overflow'}"
                        v-else
                      >{{item[column.field] }}</span>
                      <!-- End of customize column data -->
                    </td>
                  </tr>
                  <tr>
                    <td class="fw-semi-bold text-right">TOTAL ({{total_count}})</td>
                    <td
                      class="fw-semi-bold text-right"
                    >{{ Number(total_amount.total_inv_count_id).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="fw-semi-bold text-right"
                    >{{ orgCurrencySymbol+" "+Number(total_amount.total_without_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="fw-semi-bold text-right"
                    >{{ orgCurrencySymbol+" "+Number(total_amount.total_with_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="fw-semi-bold text-right"
                    >{{ orgCurrencySymbol+" "+Number(total_amount.due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      v-if="reported_columns.length > 0 && show_columns_length > 0"
                      :colspan="parseInt(reported_columns.length) - 0"
                    ></td>
                  </tr>
                </template>
              </tbody>
            </table>
            <p class="ml-4" v-if="lists.length != 0">
              Amount is displayed in your base currency
              <b-badge variant="success" size="xs" style="height:20px">{{orgCurrency}}</b-badge>
            </p>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Sales by Item pagination and data showing -->
    <b-row
      v-if="lists.length > 0||arrow"
      style="width: 100%;position: absolute;border-top:1px solid #e0e0e0"
      class="px-pad"
    >
      <b-col xl="5" md="6" lg="6" sm="8" class="mt-2 pt-1 px-0">
        <nav v-if="lists.length > 0" class="float-left">
          <p>
            Showing {{ (total_count != 0 ) ? ((page - 1) * count) + 1 : 0 }} to {{ ((page - 1) * show) + lists.length }}
            of {{ total_count }} entries
            <span
              class="btn-group dropdown"
            >
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                size="xs"
                :show="false"
                :text="count"
                left
              >
                <router-link
                  :to="{ name : 'SalesCustomer',query: {sort:sort,label:label,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1,show: 10,select_columns:$route.query.select_columns,custom:$route.query.custom} }"
                  class="text-dark text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 10">10</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'SalesCustomer',query: {sort:sort,label:label,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1,show: 25,select_columns:$route.query.select_columns,custom:$route.query.custom} }"
                  class="text-dark text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 25">25</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'SalesCustomer',query: {sort:sort,label:label,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1 ,show: 50,select_columns:$route.query.select_columns,custom:$route.query.custom} }"
                  class="text-dark text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 50">50</b-dropdown-item-button>
                </router-link>
              </b-dropdown>
            </span> rows per page
          </p>
        </nav>
      </b-col>
      <b-col xl="2" md="2" lg="2" sm="4" style="text-align: center;" class="mt-2 pt-1 px-0">
        <div v-if="arrow">
          <a @click="left('#reportScrollCol')" class="mr-2">
            <i class="fa fa-angle-left mr-1 fw-bold round-icon"></i>

            <!-- <b-badge class="badge" variant="light">&lt;</b-badge> -->
          </a>
          <a @click="right('#reportScrollCol')">
            <i class="fa fa-angle-right ml-1 fw-bold round-icon"></i>

            <!-- <b-badge class="badge" variant="light">&gt;</b-badge> -->
          </a>
        </div>
      </b-col>
      <b-col xl="5" md="4" lg="4" sm="12" class="mt-2 pt-1 px-0 d-md-block d-none">
        <template v-if="show<total_count">
          <nav class="float-right">
            <ul class="pagination">
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'SalesCustomer',query: {sort:sort,label:label,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page - 1 ,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom} }"
                  >
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'SalesCustomer',query: {sort:sort,label:label,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1 ,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom} }"
                >First</router-link>
              </li>
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'SalesCustomer',query: {sort:sort,label:label,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page - 1 ,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom} }"
                  >Previous</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Previous</a>
                </template>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'SalesCustomer',query: {sort:sort,label:label,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page + 1,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom } }"
                  >Next</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Next</a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'SalesCustomer',query: {sort:sort,label:label,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: Math.ceil(total_count / count),show: count,select_columns:$route.query.select_columns,custom:$route.query.custom } }"
                >Last</router-link>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'SalesCustomer',query: {sort:sort,label:label,sales_tags:$route.query.sales_tags,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page + 1,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom } }"
                  >
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </a>
                </template>
              </li>
            </ul>
          </nav>
        </template>
      </b-col>
    </b-row>

    <!-- Customize column -->
    <b-modal
      :no-close-on-backdrop="true"
      id="salescustomer"
      title="Customize Report"
      body-class="bg-white"
      cancel-variant="light"
      ok-title="Run Report"
      size="lg"
      ref="runreport"
      @ok.prevent="selectedfilter={},onRunReport(0)"
    >
      <!-- Validation for salescustomer reports -->
      <b-row>
        <b-col xl="12" lg="12" md="12" xs="12" sm="12">
          <div class="container-fluid">
            <b-alert class="alert-transparent alert-danger" :show="error_show && this.errors.any()">
              <button type="button" @click="error_show=!error_show" class="close">
                <span aria-hidden="true">&times;</span>
              </button>
              <div v-for="(item,index) in items" :key="index">
                <p
                  class="text-danger"
                  v-if="errors.has('filter_matching['+index+']')"
                >Row {{ index + 1 }} : Please enter the matching type</p>
                <p
                  class="text-danger"
                  v-if="errors.has('cust_name['+index+']')"
                >Row {{ index + 1 }} : Please enter the customize name</p>
                <p
                  class="text-danger"
                  v-if="errors.has('type['+index+']')"
                >Row {{ index + 1 }} : Please enter customize type</p>
                <p
                  class="text-danger"
                  v-if="errors.has('value['+index+']')"
                >Row {{ index + 1 }} : Please enter customize value</p>
              </div>
            </b-alert>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-row>
            <b-col xl="12" lg="12" md="12" sm="12" xs="12">
              <b-form-group label="Date" label-for="date" :label-cols="3">
                <GlobalDateRangePicker
                  class="pl-4"
                  :singleDatePicker="false"
                  v-on:setDateRange="getDateRange($event)"
                  :fromDate="from_date"
                  :toDate="to_date"
                />
                <input type="hidden" name="from_date" v-model.trim="from_date" />
                <input type="hidden" name="to_date" v-model.trim="to_date" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="8" lg="8" md="8" sm="8" xs="8">
              <b-form-group label="Tag List" label-for="taglist" :label-cols="5">
                <b-form-select class="form-control" v-model.trim="sales_tags">
                  <option></option>
                  <option
                    v-for="item in taglist.sales_tags"
                    :key="item.value"
                    :value="item.value"
                  >{{ item.label }}</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group label="Advanced Filters" label-for="adv-filter" :label-cols="5" />
          <b-row v-for="(item,index) in items" :key="index">
            <b-col xl="2" lg="2" md="2" sm="2" xs="2">
              <b-form-group>
                <b-form-select
                  class="form-control"
                  v-model.trim="item.filter_matching"
                  v-validate="'required'"
                  :name="'filter_matching['+index+']'"
                  v-if="index > 0"
                >
                  <option value="and">And</option>
                  <option value="or">Or</option>
                </b-form-select>
                <input
                  type="text"
                  v-else
                  class="form-control"
                  v-model.trim="item.filter_matching"
                  v-validate="'required'"
                  :name="'filter_matching['+index+']'"
                  disabled
                />
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="5" md="5" sm="5" xs="5">
              <b-form-group>
                <b-form-select
                  class="form-control"
                  v-model.trim="item.field"
                  v-validate="'required'"
                  :name="'cust_name['+index+']'"
                >
                  <option value="customer_name">Customer Name</option>
                  <!-- <option value="cus_tags">Customer Tags</option> -->
                </b-form-select>
              </b-form-group>
            </b-col>

            <b-col xl="3" lg="5" md="5" sm="5" xs="5">
              <b-form-group>
                <b-form-select
                  class="form-control"
                  v-model.trim="item.comparator"
                  v-validate="'required'"
                  :name="'type['+index+']'"
                >
                  <option value="1" v-if="item.field != 'cus_tags'">Is</option>
                  <option value="2" v-if="item.field != 'cus_tags'">Is not</option>
                  <option value="5" v-if="item.field != 'cus_tags'">Starts with</option>
                  <option value="6" v-if="item.field != 'cus_tags'">Ends with</option>
                  <option value="7" v-if="item.field != 'cus_tags'">Contains</option>
                  <option value="8" v-if="item.field != 'cus_tags'">Does not contains</option>
                  <option value="10" v-if="item.field == 'cus_tags'">In</option>
                  <option value="11" v-if="item.field == 'cus_tags'">Not In</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="5" md="5" sm="5" xs="5">
              <b-form-group>
                <input
                  v-if="item.field == 'customer_name'"
                  type="text"
                  class="form-control"
                  v-model.trim="item.value"
                  v-validate="'required'"
                  :name="'value['+index+']'"
                />
                <b-form-select
                  class="form-control"
                  v-model.trim="item.value"
                  v-if="item.field == 'cus_tags'"
                >
                  <option
                    v-for="item in taglist.cus_tags"
                    :key="item.value"
                    :value="item.value"
                  >{{ item.label }}</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col xl="1" lg="1" md="1" sm="1" xs="1">
              <b-form-group>
                <span>
                  <i class="glyphicon glyphicon-trash" @click="removeRow(index)"></i>
                </span>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col xl="12" md="12" lg="12" sm="12" xs="12">
          <span
            class="text-link cursor_pointer fw-semi-bold"
            @click="addNewRow()"
            v-if="items.length<10"
          >+ Add more</span>
          <span v-else>
            <i class="fa fa-exclamation-triangle pl-2 text-warning fa-md"></i>
            Filter conditions must be within ten criteria
          </span>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      id="custom_index"
      title="Customize Report"
      body-class="bg-white"
      cancel-variant="light"
      ok-title="Run Report"
      size="lg"
      @ok.prevent="selectedfilter={},onRunReport(0)"
      ref="runreport"
    >
      <b-row>
        <b-col>
          <p class="fw-semi-bold pl-2">General</p>
          <b-form-checkbox
            class="pt-1"
            v-model="show_columns"
            v-for="(group, index) in available_columns"
            v-if="group.Group=='customer'||group.Group=='general'||group.Group=='pymnt_terms'||group.Group=='sales_person'||group.Group=='project'||group.Group=='gst_type'||group.Group=='credit_limit'"
            :value=" {group:group.Group,field: group.field}"
            :key="index"
            @change="group.checked = !group.checked"
            style="display:block;padding-left:30px"
          >{{group.title}}</b-form-checkbox>
        </b-col>
        <b-col>
          <p class="fw-semi-bold pl-2">Sales</p>
          <b-form-checkbox
            class="pt-1"
            v-model="show_columns"
            v-for="(group, index) in available_columns"
            v-if="group.Group=='export'"
            :value=" {group:group.Group,field: group.field}"
            :key="index"
            @change="group.checked = !group.checked"
            style="display:block;padding-left:25px"
          >{{group.title}}</b-form-checkbox>
        </b-col>
      </b-row>
    </b-modal>
    <SaveFilterForm :saveforfuture="saveforfuture" :page="filterpage" :item="filteritems" />
    <GlobalModal
      :content="content"
      :module="module"
      :title="title"
      :data="globalmodaldata"
      :isRoute="isRoute"
      :RoutePlace="RoutePlace"
      :type="globalmodaltype"
    />
    <GlobalExportModal
      v-if="export_modal"
      :data="export_data"
      :columns="export_xl"
      :file_name="'Sales by customer'"
      @downloaded="export_modal=false"
    />
    <!--  back to top  -->
  </div>
</template>
<!-- Sales by Customer  Script -->
<script>
import { scrollTable } from "@/mixins/scrollTable"; //functions call for table scroll

import { mapState, mapGetters } from "vuex";
import store from "@/store/index";
import Vue from "vue";
import moment from "moment";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import { formatDate } from "@/mixins/formatDate";
import SaveFilterForm from "@/pages/Reports/SaveFilterForm";

import $ from "jquery";
function getPageSalesByCustomers(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1;
  const show = parseInt(routeTo.query.show) || 10;
  const sort = routeTo.query.sort || "";
  const label = routeTo.query.label || "";
  store
    .dispatch("reports/fetchCustomerLists", {
      page: currentPage,
      show: show,
      sort: sort,
      label: label,
      query: routeTo.query
    })
    .then(() => {
      routeTo.params.page = currentPage;
      routeTo.params.show = show;
      routeTo.params.sort = sort;
      routeTo.params.label = label;
      next();
    });
}
export default {
  components: {
    VueBootstrapTypeahead,
    SaveFilterForm
  },
  mixins: [formatDate, scrollTable],
  props: {
    page: {
      type: Number,
      required: true
    },
    show: {
      type: Number,
      required: true
    },
    label: [String, Number],
    sort: [String, Number]
  },
  name: "SalesCustomer",
  data() {
    return {
      export_data: [],
      export_modal: false,
      psort: this.sort,
      plabel: this.label,
      filterpage: "create",
      filteritems: "",
      arrow: false,
      isRoute: "",
      RoutePlace: "",
      content: "",
      module: "",
      globalmodaltype: "",
      globalmodaldata: "",
      title: "",
      export_xl: {
        Customer: "cus_name",
        COUNT: "inv_count_id",
        Sales: "amt_without_tax",
        "WITH TAX": "amt_with_tax",
        BALANCE: "cus_bal_amt"
      },
      show_columns: [],
      show_columns_length: 0,
      reported_columns: [],
      available_columns: [
        {
          Group: "customer",
          field: "cus_fname",
          title: "First Name",
          checked: false,
          colWidth: 180,
          align: "overflow"
        },
        {
          Group: "customer",
          field: "cus_lname",
          title: "Last Name",
          checked: false,
          colWidth: 180,
          align: "overflow"
        },
        {
          Group: "customer",
          field: "cus_comp_name",
          title: "Company Name",
          checked: false,
          colWidth: 180,
          align: "overflow"
        },
        {
          Group: "customer",
          field: "cus_legacy_id",
          title: "Customer ID",
          checked: false,
          colWidth: 150,
          align: ""
        },
        {
          Group: "customer",
          field: "cus_ph_no_1",
          title: "Phone",
          checked: false,
          colWidth: 110,
          align: ""
        },
        {
          Group: "customer",
          field: "cus_mail",
          title: "Mail",
          checked: false,
          colWidth: 150,
          align: "overflow"
        },
        {
          Group: "gst_type",
          field: "gst_type_name",
          title: "Gst Type",
          checked: false,
          colWidth: 210,
          align: ""
        },

        {
          Group: "customer",
          field: "cus_gst_no",
          title: "Gst No",
          checked: false,
          colWidth: 145,
          align: ""
        },
        {
          Group: "customer",
          field: "cus_pan_no",
          title: "Pan No",
          checked: false,
          colWidth: 115,
          align: ""
        },
        {
          Group: "customer",
          field: "place_of_supply",
          title: "Place of supply",
          checked: false,
          colWidth: 200,
          align: ""
        },
        {
          Group: "general",
          field: "cus_twitter_id",
          title: "Twitter id",
          checked: false,
          colWidth: 150,
          align: "overflow"
        },
        {
          Group: "general",
          field: "cus_facebook_id",
          title: "Facebook id",
          checked: false,
          colWidth: 150,
          align: "overflow"
        },
        {
          Group: "general",
          field: "cus_website",
          title: "Website",
          checked: false,
          colWidth: 150,
          align: "overflow"
        },
        {
          Group: "general",
          field: "cus_dept",
          title: "Designation",
          checked: false,
          colWidth: 150,
          align: "overflow"
        },
        {
          Group: "general",
          field: "cus_currency",
          title: "Currency",
          checked: false,
          colWidth: 180,
          align: ""
        },
        {
          Group: "pymnt_terms",
          field: "term_name",
          title: "Payment Term",
          checked: false,
          colWidth: 145,
          align: ""
        },
        {
          Group: "credit_limit",
          field: "credit_limit",
          title: "Credit Limit",
          checked: false,
          colWidth: 180,
          align: "right"
        },

        {
          Group: "export",
          field: "export_amt_without_tax",
          title: "Sales(FCY)",
          checked: false,
          colWidth: 140,
          align: "right"
        },
        {
          Group: "export",
          field: "export_amt_with_tax",
          title: "With Tax(FCY)",
          checked: false,
          colWidth: 140,
          align: "right"
        },

        {
          Group: "export",
          field: "export_cus_bal_amt",
          title: "Balance(FCY)",
          checked: false,
          colWidth: 140,
          align: "right"
        }
      ],
      saveforfuture: {},
      error_show: false,
      items: [],
      columns: this.$route.query.show_columns,
      sales_tags: this.$route.query.sales_tags || "",
      from_date:
        this.$route.query.from_date ||
        this.formatDate(moment().startOf("month")),
      to_date:
        this.$route.query.to_date || this.formatDate(moment().endOf("month")),
      Selected: "",
      org_name: this.$AppDetails.organization.comp_name || "",
      datePickerReport: 0
    };
  },
  updated() {
    this.arrow = this.scrollbar($("#reportScrollCol")) ? true : false;
  },
  mounted() {
    this.arrow = this.scrollbar($("#reportScrollCol")) ? true : false;
  },

  methods: {
    async exportModal() {
      this.export_modal = await true;
      this.export_data = await this.fetchExportData();
      this.$root.$emit("bv::show::modal", "exportdata");
    },
    async savefilterform() {
      this.saveforfuture = await {
        from_date: this.from_date,
        to_date: this.to_date,
        label: this.label,
        sort: this.sort,
        sales_tags: this.sales_tags,
        sales_person: this.sales_person,
        show_columns: this.show_columns,
        available_columns: this.available_columns,
        items: this.items
      };
      await this.$root.$emit("bv::show::modal", "savefilterform");
    },
    runcustomreport(item) {
      this.selectedfilter = item;
      var filter_content = JSON.parse(item.filter_content);
      this.from_date = filter_content.from_date;
      this.to_date = filter_content.to_date;
      this.plabel = JSON.parse(JSON.stringify(filter_content.label));
      this.psort = JSON.parse(JSON.stringify(filter_content.sort));
      this.sales_tags = filter_content.sales_tags;
      this.show_columns = filter_content.show_columns;
      this.items = filter_content.items;
      this.available_columns = filter_content.available_columns;
      this.onRunReport(0);
    },
    //  delete whole invoice
    handlingapprovingmodal(ev) {
      this.content = ev.content;
      this.module = ev.module;
      this.globalmodaldata = ev.data;
      this.title = ev.title;
      this.isRoute = ev.isRoute;
      this.RoutePlace = ev.RoutePlace;
      this.globalmodaltype = ev.type;
      this.$root.$emit("bv::show::modal", "handlingapprovingmodal");
    },

    async fetchExportData() {
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const response = await store
        .dispatch("reports/fetchCustomerExportLists", {
          page: currentPage,
          show: show,
          sort: sort,
          label: label,
          query: this.$route.query
        })
        .then(() => {
          return this.export;
        });
      return response;
    },

    closeModal(id) {
      this.$refs[id].hide();
    },

    addNewRow() {
      this.items.push({
        filter_matching: "",
        field: "",
        comparator: "",
        value: ""
      });
      this.items[0].filter_matching = "When";
    },
    onRunReport(runreport) {
      this.datePickerReport = 1;
      this.$validator.validateAll().then(result => {
        if (result) {
          if (runreport == 0 && this.$refs.daterangeupdate) {
            var child = this.$refs.daterangeupdate;
            child.checkConsole({
              startDate: this.from_date,
              endDate: this.to_date
            });
          }
          this.reported_columns = JSON.parse(
            JSON.stringify(this.available_columns)
          );
          this.show_columns_length = JSON.parse(
            JSON.stringify(this.show_columns)
          ).length;
          //To add export for selected columns
          for (var i = 0; i < this.reported_columns.length; i++) {
            if (this.reported_columns[i].checked == true) {
              this.export_xl[
                this.reported_columns[i].title
              ] = this.reported_columns[i].field;
            } else {
              delete this.export_xl[this.reported_columns[i].title];
            }
          }

          this.$router.push({
            name: this.$route.name,
            query: {
              from_date: this.from_date,
              to_date: this.to_date,
              label: $.isEmptyObject(this.selectedfilter)
                ? this.label
                : this.plabel,
              sort: $.isEmptyObject(this.selectedfilter)
                ? this.sort
                : this.psort,
              sales_tags: this.sales_tags,
              select_columns: JSON.stringify({
                columns: JSON.stringify(this.show_columns)
              }),
              custom: JSON.stringify({
                columns: JSON.stringify(this.items)
              })
            }
          });
        } else {
          this.error_show = true;
        }
      });
    },
    getDateRange(event, runreport) {
      this.from_date = event.startDate;
      this.to_date = event.endDate;
      if (runreport == 1) {
        this.onRunReport(runreport);
      } else {
        this.datePickerReport = 1;
      }
    },

    changeSelectOption(field, value) {
      Vue.set(this, field, value);
    },
    removeRow(index) {
      this.items.splice(index, 1);
      this.items[0].filter_matching = "When";
    }
  },
  created() {
    // this.from_date = this.$route.query.from_date;
    // this.to_date = this.$route.query.to_date;
    if (!$.isEmptyObject(this.selectedfilter)) {
      this.runcustomreport(this.selectedfilter);
    } else if (
      Object.entries(this.$route.query).length === 1 &&
      this.$route.query.constructor === Object
    ) {
      this.$router.push({
        name: this.$route.name,
        query: {
          from_date: this.from_date,
          to_date: this.to_date,

          label: this.label,
          sort: this.sort,
          sales_tags: this.sales_tags,
          select_columns: JSON.stringify({
            columns: JSON.stringify(this.show_columns)
          }),
          custom: JSON.stringify({
            columns: JSON.stringify(this.items)
          })
        }
      });
    }
    if (
      typeof this.$route.query.custom != "undefined" &&
      this.$route.query.custom != null
    ) {
      this.from_date = this.$route.query.from_date;
      this.columns = this.$route.query.show_columns;
      this.to_date = this.$route.query.to_date;
      this.items =
        Object.entries(JSON.parse(this.$route.query.custom)).length === 0 &&
        JSON.parse(this.$route.query.custom).constructor === Object
          ? []
          : JSON.parse(JSON.parse(this.$route.query.custom)["columns"]);
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store.dispatch("general/fetchtaglist");
    store.dispatch(
      "general/getallcustomfilter",
      JSON.stringify({
        report_type: routeTo.meta.title
      })
    );
    getPageSalesByCustomers(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    typeof this.$refs.runreport != "undefined"
      ? this.$refs.runreport.hide()
      : "";
    getPageSalesByCustomers(routeTo, next);
  },
  computed: {
    ...mapState({
      lists: state => state.reports.lists,
      total_count: state => state.reports.total_count,
      count: state => state.reports.count,
      total_amount: state => state.reports.total_amount,
      taglist: state => state.general.taglist,
      export: state => state.reports.export,
      reportsfilter: state => state.general.reportsfilter
    }),
    ...mapGetters(["orgCurrencySymbol", "orgCurrency"]),
    selectedfilter: {
      get() {
        return this.$store.state.general.selectedfilter;
      },
      set(val) {
        this.$store.state.general.selectedfilter = val;
      }
    },
    oldRoute: {
      get() {
        return this.$store.state.general.oldRoute;
      },
      set(val) {
        this.$store.state.general.oldRoute = val;
      }
    }
  }
};
</script>

<!--  Sales by Customer style -->
<style scoped>
.pagination > .page-item > .page-link,
.pagination > .page-item > span {
  border-radius: unset;
  margin: 0;
  background: transparent;
}
.ver-align {
  padding-top: 10px;
  text-decoration: none;
}
.content {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  padding: 40px 40px 60px;
  background-color: #fff;
}
</style>
